export default "__VITE_ASSET__ICi0AMht__"